import { Common, color } from '@stockbit/ui';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

const { Flex, Text } = Common;

const loadingIcon = (
  <LoadingOutlined style={{ fontSize: 24, color: color.highgray }} spin />
);

export default function AuthModalLoading() {
  return (
    <Flex
      data-cy="auth-modal-loading"
      direction="column"
      justify="center"
      align="center"
      width="100%"
      height="374px"
    >
      <Spin indicator={loadingIcon} />
      <Text color="#858585" mt="16px">
        Authenticating...
      </Text>
    </Flex>
  );
}
